export default __webpack_public_path__ + "static/media/Comp 2_00049.f6bc6e59.png";